<template>
  <div class="coupon-detail">
    <!-- 页面头部 -->
    <div class="detail-header">
      <div class="header-left">
        <el-button
          type="text"
          icon="el-icon-arrow-left"
          @click="goBack"
          class="back-btn"
        >
          返回列表
        </el-button>
        <h2 class="page-title">优惠券详情</h2>
      </div>
      <div class="header-right">
        <el-tag :type="getStatusType(detailData)" size="medium">
          {{ getStatusName(detailData) }}
        </el-tag>
      </div>
    </div>

    <!-- 详情内容 -->
    <div class="detail-container">
      <!-- 商家信息卡片 -->
      <el-card class="info-card" shadow="hover">
        <div slot="header" class="card-header">
          <i class="el-icon-shop"></i>
          <span>商家信息</span>
        </div>
        <div class="card-content">
          <el-row :gutter="30">
            <el-col :span="6">
              <div class="info-item">
                <div class="info-label">商家名称</div>
                <div class="info-value">{{ detailData.merchantName }}</div>
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <div class="info-item">
                <div class="info-label">商家类型</div>
                <div class="info-value">
                  {{ detailData.merchantType || "餐饮" }}
                </div>
              </div>
            </el-col> -->
            <el-col :span="6">
              <div class="info-item">
                <div class="info-label">联系人</div>
                <div class="info-value">{{ detailData.merchantUserName }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <div class="info-label">联系电话</div>
                <div class="info-value">{{ detailData.merchantPhone }}</div>
              </div>
            </el-col>
          </el-row>
         
          <el-row :gutter="30" style="margin-top: 20px">
            <el-col :span="24">
              <div class="info-item">
                <div class="info-label">商家地址</div>
                <div class="info-value">{{ detailData.merchantAddress }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!-- 优惠券信息卡片 -->
      <el-card class="info-card" shadow="hover">
        <div slot="header" class="card-header">
          <i class="el-icon-ticket"></i>
          <span>优惠券信息</span>
        </div>
        <div class="card-content">
          <el-row :gutter="30">
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">优惠券名称</div>
                <div class="info-value">{{ detailData.name }}</div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <div class="info-label">优惠券类型</div>
                <div class="info-value">
                  <el-tag :type="getCouponTypeTag(detailData.discountType)">
                    {{ getCouponTypeName(detailData.discountType) }}
                  </el-tag>
                </div>
              </div>
            </el-col>
              <el-col :span="6" v-if="detailData.discountType == 4">
              <div class="info-item">
                <div class="info-label">赠送金额</div>
                <div class="info-value">{{ detailData.discountValue }}元</div>
              </div>
            </el-col>
            <el-col :span="6" v-else-if="detailData.discountType == 3">
              <div class="info-item">
                <div class="info-label">折扣</div>
                <div class="info-value">{{ detailData.discountValue }}折</div>
              </div>
            </el-col>
            <el-col :span="6" v-else-if="detailData.discountType == 5">
              <div class="info-item">
                <div class="info-label">抵扣金额</div>
                <div class="info-value">{{ detailData.discountValue }}元</div>
              </div>
            </el-col>
          </el-row>
         
          <!-- 优惠说明 -->
          <el-row :gutter="30" style="margin-top: 20px" v-if="detailData.description">
            <el-col :span="24">
              <div class="info-item">
                <div class="info-label">优惠说明</div>
                <div class="info-value content-text">
                  {{ detailData.description }}
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 使用说明 -->
          <el-row :gutter="30" style="margin-top: 20px" v-if="detailData.usedInfo">
            <el-col :span="24">
              <div class="info-item">
                <div class="info-label">使用说明</div>
                <div class="info-value content-text">
                  {{ detailData.usedInfo }}
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-top: 20px">
            <el-col :span="6">
              <div class="info-item">
                <div class="info-label">发放数量</div>
                <div class="info-value number-value">
                  {{ detailData.totalNum }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <div class="info-label">已领取数量</div>
                <div class="info-value number-value">
                  {{ detailData.issueNum }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="info-item">
                <div class="info-label">已核销数量</div>
                <div class="info-value number-value">
                  {{ detailData.usedNum }}
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <div class="info-item">
                <div class="info-label">领取未核销数量</div>
                <div class="info-value number-value">{{ detailData.unusedCount }}</div>
              </div>
            </el-col> -->
          </el-row>
          <el-row :gutter="30" style="margin-top: 20px">
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">上架有效期</div>
                <div class="info-value">
                  {{ detailData.issueBeginTime }}--{{ detailData.issueEndTime }}
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">使用有效期</div>
                <div class="info-value">
                  {{ detailData.termBeginTime }}--{{ detailData.termEndTime }}
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-top: 20px">
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">使用时间段</div>
                <div class="info-value">
                  {{ detailData.durationStart }}--{{ detailData.durationEnd }}
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">创建时间</div>
                <div class="info-value">{{ detailData.crtTime }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-top: 20px">
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">更新时间</div>
                <div class="info-value">{{ detailData.updTime }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">当前状态</div>
                <div class="info-value">
                  <el-tag :type="getStatusType(detailData)" size="medium">
                    {{ getStatusName(detailData) }}
                  </el-tag>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!-- 审核信息卡片（仅待审核状态显示） -->
      <el-card
        class="info-card"
        shadow="hover"
        v-if="detailData.auditStatus === '1' || detailData.auditStatus === 1"
      >
        <div slot="header" class="card-header">
          <i class="el-icon-document-checked"></i>
          <span>审核信息</span>
        </div>
        <div class="card-content">
          <!-- 基本信息 -->
          <el-row :gutter="30">
            <el-col :span="12">
              <div class="info-item">
                <div class="info-label">审核状态</div>
                <div class="info-value">
                  <el-tag type="warning" size="medium">待审核</el-tag>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="12">
              <div class="info-item">
                <div class="info-label">提交时间</div>
                <div class="info-value">{{ detailData.createTime }}</div>
              </div>
            </el-col> -->
          </el-row>

          <!-- 审核表单 -->
          <el-divider content-position="left">审核操作</el-divider>
          <el-form
            :model="auditForm"
            :rules="auditRules"
            ref="auditForm"
            label-width="100px"
            class="audit-form"
          >
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="审核结果" prop="auditResult">
                  <el-radio-group v-model="auditForm.auditResult">
                    <el-radio label="1">
                      <i
                        class="el-icon-check"
                        style="color: #67c23a; margin-right: 5px"
                      ></i>
                      通过
                    </el-radio>
                    <el-radio label="0">
                      <i
                        class="el-icon-close"
                        style="color: #f56c6c; margin-right: 5px"
                      ></i>
                      不通过
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="通知方式">
                  <el-checkbox-group v-model="auditForm.notifyMethods">
                    <el-checkbox label="wechat">
                      <i
                        class="el-icon-chat-dot-round"
                        style="margin-right: 5px"
                      ></i>
                      微信服务
                    </el-checkbox>
                    <el-checkbox label="sms">
                      <i class="el-icon-message" style="margin-right: 5px"></i>
                      短信通知
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="审核意见" prop="auditRemark">
                  <el-input
                    v-model="auditForm.auditRemark"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入审核意见..."
                    maxlength="200"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="submitAudit"
                    :loading="auditLoading"
                  >
                    <i class="el-icon-check"></i>
                    提交审核
                  </el-button>
                  <el-button @click="resetAuditForm">
                    <i class="el-icon-refresh"></i>
                    重置
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 操作记录卡片 -->
        <!-- <el-card class="info-card" shadow="hover">
          <div slot="header" class="card-header">
            <i class="el-icon-time"></i>
            <span>操作记录</span>
          </div>
          <div class="card-content">
            <el-timeline>
              <el-timeline-item
                v-for="(record, index) in operationRecords"
                :key="index"
                :timestamp="record.time"
                :type="record.type"
                :icon="getOperationIcon(record.type)"
              >
                <div class="operation-item">
                  <div class="operation-content">{{ record.content }}</div>
                  <div class="operation-operator">
                    <i class="el-icon-user"></i>
                    {{ record.operator }}
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-card> -->
    </div>
  </div>
</template>

<script>
import { shopCoupon, shopCouponAuditNew } from "@/api/url";
export default {
  name: "coupon-detail",
  data() {
    return {
      detailData: {},
      operationRecords: [],
      // 审核相关
      auditForm: {
        id: null,
        auditResult: "1",
        auditRemark: "",
        notifyMethods: [],
      },
      auditLoading: false,
      auditRules: {
        // auditResult: [
        //   { required: true, message: "请选择审核结果", trigger: "change" },
        // ],
        auditRemark: [
          { required: true, message: "请输入审核意见", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.loadDetailData();
  },
  methods: {
    // 加载详情数据
    async loadDetailData() {
      // const couponId = this.$route.params.id;
      console.log("加载优惠券详情coupon:",  this.$route.params.coupon);
      // 这里应该根据ID从API获取数据，现在使用模拟数据
     // const res = await this.$get(`${shopCoupon()}/${couponId}`);
     // this.detailData = res?.data || {};
      this.detailData = this.$route.params.coupon || {};
      // 初始化审核表单
      this.auditForm.id = this.detailData.id;
    },

    // 加载操作记录
    loadOperationRecords() {
      const baseRecords = [
        {
          time: this.detailData.createTime,
          type: "primary",
          content: "优惠券创建",
          operator: "张三",
        },
      ];

      if (this.detailData.status === "0") {
        // 待审核状态，只有创建记录
        this.operationRecords = baseRecords;
      } else if (this.detailData.status === "1") {
        // 审核不通过状态
        this.operationRecords = [
          ...baseRecords,
          {
            time: "2024-01-19 12:00:00",
            type: "danger",
            content: "优惠券审核不通过",
            operator: "李四",
          },
        ];
      } else if (this.detailData.status === "2") {
        // 上架中状态
        this.operationRecords = [
          ...baseRecords,
          {
            time: "2024-01-15 11:00:00",
            type: "success",
            content: "优惠券审核通过",
            operator: "李四",
          },
          {
            time: "2024-01-15 11:30:00",
            type: "info",
            content: "优惠券上架",
            operator: "王五",
          },
        ];
      } else {
        // 其他状态
        this.operationRecords = [
          ...baseRecords,
          {
            time: "2024-01-15 11:00:00",
            type: "success",
            content: "优惠券审核通过",
            operator: "李四",
          },
          {
            time: "2024-01-15 11:30:00",
            type: "info",
            content: "优惠券上架",
            operator: "王五",
          },
          {
            time: "2024-01-16 09:00:00",
            type: "warning",
            content: "优惠券数据更新",
            operator: "赵六",
          },
        ];
      }
    },

    // 返回列表
    goBack() {
      this.$router.go(-1);
    },

    // 获取优惠券类型名称
    getCouponTypeName(type) {
      const typeMap = {
        // 1: "满减券",
        4: "赠送券",
        3: "折扣券",
        5: "抵扣券",
      };
      return typeMap[type] || "未知";
    },

    // 获取优惠券类型标签样式
    getCouponTypeTag(type) {
      const tagMap = {
        1: "danger",
        2: "warning",
        3: "success",
      };
      return tagMap[type] || "info";
    },

    // 获取状态名称
    getStatusName(row) {
      // 根据优先级判断状态：已失效 > 审核不通过 > 待审核 > 下架中 > 上架中
      if (row?.status === 2 || row?.status === "2") {
        return "已失效";
      }
      if (row?.auditStatus === 2 || row?.auditStatus === "2") {
        return "审核不通过";
      }
      if (row?.auditStatus === 1 || row?.auditStatus === "1") {
        return "待审核";
      }
      if (row?.published === 2 || row?.published === "2") {
        return "下架中";
      }
      if (row?.published === 1 || row?.published === "1") {
        return "上架中";
      }
      return "未知";
    },

    // 获取状态类型
    getStatusType(row) {
      // 根据优先级判断状态类型：已失效 > 审核不通过 > 待审核 > 下架中 > 上架中
      if (row?.status === 2 || row?.status === "2") {
        return "info"; // 已失效
      }
      if (row?.auditStatus === 2 || row?.auditStatus === "2") {
        return "danger"; // 审核不通过
      }
      if (row?.auditStatus === 1 || row?.auditStatus === "1") {
        return "warning"; // 待审核
      }
      if (row?.published === 2 || row?.published === "2") {
        return "info"; // 下架中
      }
      if (row?.published === 1 || row?.published === "1") {
        return "success"; // 上架中
      }
      return "info"; // 默认
    },

    // 获取操作图标
    getOperationIcon(type) {
      const iconMap = {
        primary: "el-icon-plus",
        success: "el-icon-check",
        warning: "el-icon-warning",
        info: "el-icon-info",
      };
      return iconMap[type] || "el-icon-time";
    },

    // 重置审核表单
    resetAuditForm() {
      this.auditForm = {
        id: this.detailData.id,
        auditResult: "",
        auditRemark: "",
        notifyMethods: [],
      };
      if (this.$refs.auditForm) {
        this.$refs.auditForm.resetFields();
      }
    },

    // 提交审核
    submitAudit() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          this.auditLoading = true;

          // 设置表单ID
          this.auditForm.id = this.detailData.id;

          // 这里应该调用审核API
          this.$get(`${shopCouponAuditNew()}`, {
            couponId: this.auditForm.id,
            auditStatus: this.auditForm.auditResult === "1" ? "0" : "2",
            auditInfo: this.auditForm.auditRemark,
          })
            .then((res) => {
              if (res.status === 200) {
                this.auditLoading = false;
                this.$message.success(
                  `${
                    this.auditForm.auditResult === "1" ? "通过" : "不通过"
                  }审核成功`
                );
                this.auditForm = {}; // 清空表单数据，防止重复提交导致问题
                // this.loadDetailData(); // 重新加载数据
                this.goBack(); // 返回列表页
                return;
              }
              throw new Error(
                res.message ||
                  `${
                    this.auditForm.auditResult === "1" ? "通过" : "不通过"
                  }审核失败`
              );
            })
            .catch((error) => {
              this.auditLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.coupon-detail {
  padding: 20px;
  background-color: #f5f5f5;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 移除可能的父容器高度限制 */
.coupon-detail * {
  box-sizing: border-box;
}

/* 页面头部 */
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
}

.back-btn {
  margin-right: 20px;
  font-size: 16px;
  color: #409eff;
}

.back-btn:hover {
  color: #66b1ff;
}

.page-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}

.header-right {
  display: flex;
  align-items: center;
}

/* 详情容器 */
.detail-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 40px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  min-height: 0;
}

/* 自定义滚动条样式 */
.detail-container::-webkit-scrollbar {
  width: 6px;
}

.detail-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.detail-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.detail-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 信息卡片 */
.info-card {
  border-radius: 8px;
  border: none;
  overflow: hidden;
  flex-shrink: 0;
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.card-header i {
  margin-right: 8px;
  font-size: 18px;
  color: #409eff;
}

.card-content {
  padding: 20px;
}

/* 信息项 */
.info-item {
  margin-bottom: 20px;
}

.info-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
  font-weight: 500;
}

.info-value {
  font-size: 16px;
  color: #303133;
  font-weight: 500;
  word-break: break-all;
  line-height: 1.5;
  min-height: 24px;
}

.content-text {
  line-height: 1.6;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #409eff;
}

.number-value {
  font-size: 18px;
  font-weight: 600;
  color: #409eff;
}

/* 操作记录 */
.operation-item {
  padding: 8px 0;
  min-height: 50px;
}

.operation-content {
  font-size: 15px;
  color: #303133;
  margin-bottom: 6px;
  font-weight: 500;
  line-height: 1.4;
}

.operation-operator {
  font-size: 13px;
  color: #909399;
  display: flex;
  align-items: center;
  line-height: 1.4;
}

.operation-operator i {
  margin-right: 4px;
}

/* 时间线样式优化 */
.el-timeline {
  padding-left: 20px;
}

.el-timeline-item__content {
  padding-bottom: 20px;
}

/* 审核表单样式 */
.audit-form {
  margin-top: 20px;
}

.audit-form .el-form-item {
  margin-bottom: 20px;
}

.audit-form .el-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.audit-form .el-radio {
  margin-right: 0;
  margin-bottom: 0;
}

.audit-form .el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.audit-form .el-checkbox {
  margin-right: 0;
  margin-bottom: 0;
}

.audit-form .el-textarea__inner {
  resize: vertical;
  min-height: 80px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .coupon-detail {
    padding: 10px;
  }

  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .page-title {
    font-size: 20px;
  }

  .info-value {
    font-size: 14px;
  }

  .number-value {
    font-size: 16px;
  }

  .audit-form .el-radio-group {
    flex-direction: row;
    gap: 20px;
  }

  .audit-form .el-checkbox-group {
    flex-direction: row;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .detail-header {
    padding: 15px;
  }

  .back-btn {
    margin-right: 10px;
    font-size: 14px;
  }

  .page-title {
    font-size: 18px;
  }

  .audit-form .el-radio-group {
    flex-direction: column;
    gap: 10px;
  }

  .audit-form .el-checkbox-group {
    flex-direction: column;
    gap: 8px;
  }
}
</style>

<style>
/* 确保页面容器不滚动 */
.el-main {
  height: 100vh !important;
  overflow: hidden !important;
  padding: 0 !important;
}

/* 确保路由容器不滚动 */
.router-view {
  height: 100vh !important;
  overflow: hidden !important;
}

/* 确保body和html不滚动 */
html,
body {
  height: 100vh !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
